// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__15u9W","alertIcon":"ConfirmModal_alertIcon__vedRK"};